import { Input } from "@/components/ui/input";
import {
  CellProps,
  isIntegerControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

const toNumber = (value: string) =>
  value === "" ? undefined : parseInt(value, 10);

export const IntegerCell = (props: CellProps) => {
  const { data, id, enabled, uischema, path, handleChange } = props;

  return (
    <Input
      type="number"
      step="1"
      value={data ?? ""}
      onChange={(ev) => handleChange(path, toNumber(ev.target.value))}
      id={id}
      disabled={!enabled}
      autoFocus={uischema.options?.focus}
    />
  );
};

export const integerCellTester: RankedTester = rankWith(3, isIntegerControl);

export default withJsonFormsCellProps(IntegerCell);
